import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
} from "@material-ui/core";

import { getFormularioCud, updateSolicitudDiscapacidadValues } from "../../../../actions/discapacidad/discapacidadActions";
import ChevronDown from "../../../autorizaciones/UI/ChevronDown";
import AlertCircle from "../../../autorizaciones/UI/AlertCircle";
import CheckCircle from "../../../autorizaciones/UI/CheckCircle";


export const IntegracionAccordionDiagnostico = (props) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {}, formularioCud } = useSelector(
    (state) => state.discapacidad
  );
  const { solicitudSeleccionada: solicitudSeleccionadaAutoG = {} } = useSelector(
    (state) => state.afiliadoDiscapacidad
  );

  let idAfiliado_diagnosticoSolicitud = null;
  let idAfiliado_diagnosticoSolicitudAutoG = null;

  if (solicitudSeleccionada) {
    idAfiliado_diagnosticoSolicitud = solicitudSeleccionada?.idAfiliado;
  }
  if (solicitudSeleccionadaAutoG) {
    idAfiliado_diagnosticoSolicitudAutoG = solicitudSeleccionadaAutoG?.idAfiliado;
  }

  /*const [diagnostico, setDiagnostico] = 
    useState(!props.autogestion 
      ? diagnosticoSolicitud 
      : diagnosticoSolicitudAutoG
    );
  const [autoCompleteValue] = useState(null);

  const changeDiagnosticoHandler = (value) => {
    setDiagnostico(value);    
    if(!props.autogestion)
      dispatch(
        updateSolicitudDiscapacidadValues({
          diagnostico: value,
          codCie10: value ? value.codCie10 : null,
        })
      );
    else
      dispatch(
        updateSolicitudDiscapacidadAutoGValues({
          diagnostico: value,
          codCie10: value ? value.codCie10 : null,
        })
      );
  };

  useEffect(() => {
    props.setDatosCompletos(!!diagnostico);
  }, [diagnostico]);
  */

  useEffect(() => {
    if( idAfiliado_diagnosticoSolicitud || idAfiliado_diagnosticoSolicitudAutoG){
    dispatch(getFormularioCud(idAfiliado_diagnosticoSolicitud ? idAfiliado_diagnosticoSolicitud : idAfiliado_diagnosticoSolicitudAutoG,true));
    if(formularioCud?.diagnosticos?.length > 0){
      props.setDatosCompletos(true);
      formularioCud?.diagnosticos?.map((item)=> {
        dispatch(
          updateSolicitudDiscapacidadValues({
            diagnostico: item.diagnostico?.descripcion,
            codCie10:item.diagnostico?.codCie10 
          })
        );
        return null; 
      })
    }
  }
  },[dispatch,solicitudSeleccionada?.afiliado?.id_afiliado,solicitudSeleccionadaAutoG?.idAfiliado]);
  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">
          Diagnóstico{formularioCud?.diagnosticos?.length > 0 ? <CheckCircle /> : <AlertCircle /> }
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
      <Grid
          spacing={3}
          style={{
            display: "block",
            justifyContent: "center",
            marginBottom: "0.5rem",
            marginLeft:'auto',
            marginRight:'auto'
          }}
        >
          {formularioCud?.diagnosticos?.map((item)=>(
          <Typography>{item.diagnostico.descripcion}</Typography>
        ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
